import React from 'react';
import { func, string } from 'prop-types';
import { translate } from 'react-i18next';
import Copy from './copy/index';

import styles from './catalog-link.scss';
import { Input } from 'wix-style-react';

const CatalogLink = ({ link, t }) => (
  <div data-hook="mi-facebook-catalog-link" className={styles.container}>
    <div className={styles['link-input']}>
      <Input
        dataHook="mi-facebook-catalog-link-content-link-input"
        value={link}
      />
    </div>
    <Copy
      dataHook="mi-facebook-catalog-link-copy"
      toCopy={link}
      buttonText={t('facebook-catalog.modal.copy')}
      afterClickText={t('facebook-catalog.modal.copied')}
    />
  </div>
);

CatalogLink.propTypes = {
  link: string.isRequired,
  t: func.isRequired,
};

export default translate()(CatalogLink);
